import React, { Component } from "react";
import Licenses from "../../../components/Licenses/Licenses";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedForm
Description : Componente que invoca al componente Reported, para la creación y consulta de reportados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Reported
================================================================================ */
class LicensesForm extends Component{
    render(){
        return(
            <Licenses/>  
        )   
    }
}

export default LicensesForm;